export default function () {
  const widgetName = 'featuredItem';
  const widgetOpts = featuredItemOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: [''],
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    showDescription: true,
    moreButton: {
      visible: true,
      text: 'learn more',
    },
    buyNowButton: false,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    cardWidgetLoaded: function (data) {
      const featuredWidgetData = data.items;

      if (featuredWidgetData.length < 1) {
        $(`#${widgetName}`).remove();
        $('.inner-container-tier-b').addClass('no-feature-loaded');
      } else {
        createCustomSeo(featuredWidgetData[0]);
      }
    },
  });
  function createCustomSeo(widgetData) {
    const { Title } = widgetData;

    $(`#${widgetName} .card-widget-title`).replaceWith(
      `<h3 class="card-widget-title">${Title}</h3>`,
    );
    $(`#${widgetName} .moreButton`).addClass('button').removeClass('moreButton');
  }
}
